export enum EIconType {
    logos = 'logos',
    round = 'round',
    square = 'square',
    flat = 'flat',
    grey = 'grey',
    outlined = 'outlined',
    outlined_white = 'outlined_white',
    white = 'white',
}
